import sessionVars from '@/helpers/sessionVars';

const INDEX2_REDIRECT_RULES = [
  {
    params: { utm_code: 'PREDICTIT25', utm_source: 'scan', utm_campaign: 'chips' },
    url: 'https://www.predictit.org/stories/detail/84/Poker-Chips-Landing-Page',
  },
];

const INDEX2_REDIRECT_PATH = '/index2';

export default function getIndex2RedirectUrl() {
  if (window.location.pathname !== INDEX2_REDIRECT_PATH) return null;
  const params = new URL(window.location.href).searchParams;
  const rule = INDEX2_REDIRECT_RULES.find(({ params: ruleParams }) =>
    Object.keys(ruleParams).every((key) => params.get(key) === ruleParams[key]),
  );
  if (!rule) return null;
  sessionVars.check({ query: rule.params });
  return rule.url;
}
